import { List, ListItem, ListItemText } from '@mui/material';
import * as api from "api/Knowledge";
import { GlobalClassKeys } from 'assets/jss/common-styles';
import { SpinnerIndicator } from 'components/CallServer';
import MuiMessageBox from 'components/MuiExtras/MessageBox/MuiMessageBox';
import MuiColor from 'components/MuiExtras/Typography/MuiColor';
import { PublicationRelationDto } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { getPublicationSecondViewAction } from "views/Timeline/Components/FeedHelpers";

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    data: PublicationRelationDto[];
    loading: boolean;
    lastError: any;
}

interface IProps {
    publicationId: string;
}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class PublicationRelations extends React.PureComponent<Props, IState> {
    constructor(props: Props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            lastError: null
        };
    }

    ///
    private loadData() {
        api.getPublicationRelations(this.props.publicationId)
            .then((data: PublicationRelationDto[]) => {
                this.setState({ data, loading: false });
            })
            .catch((error) => {
                this.setState({ loading: false, lastError: error });
            });
    }


    ///
    public componentDidMount() {
        this.loadData();
    }

    public render() {
        const { data, lastError, loading } = this.state;

        if (loading) return <SpinnerIndicator />;

        if (lastError) return <MuiMessageBox variant="error" message={this.props.t("Views.Publication.Widgets.WidgetRelations.LoadError")} />;

        if (data.length >= 0)
            return (
                <List disablePadding>
                    {
                        data.map((v) => {
                            const action = getPublicationSecondViewAction(v.publicationType, v.publicationId);

                            return (
                                <ListItem button dense disableGutters className={GlobalClassKeys.clickable} onClick={action} >
                                    <MuiColor variant="muted">
                                        <ListItemText
                                            primary={v.title}
                                            primaryTypographyProps={
                                                {
                                                    color: "inherit",
                                                    variant: "subtitle2"
                                                }
                                            }
                                        />
                                    </MuiColor>
                                </ListItem>
                            );
                        })
                    }
                </List>
            );

        return null;
    }
}

export default withTranslation()(PublicationRelations);